import {
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_WITH_ACTIVE_ADDRESS_FAILURE,
  GET_USER_WITH_ACTIVE_ADDRESS_REQUEST,
  GET_USER_WITH_ACTIVE_ADDRESS_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  OTP_FAILURE,
  OTP_REQUEST,
  OTP_SUCCESS,
  LOGOUT,
  VERIFY_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  SELLER_REGISTER_FAILURE,
  SELLER_REGISTER_REQUEST,
  SELLER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_FAILURE,
  USER_UPDATE_PROFILE_SUCCESS
} from "./ActionType";

const initialState = {
  user: null,
  isLoading: false,
  error: null,
  jwt: null,
  otp: null,
  register: null
}

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_REQUEST:
    case LOGIN_REQUEST:
    case OTP_REQUEST:
    case VERIFY_OTP_REQUEST:
    case GET_USER_REQUEST:
    case SELLER_REGISTER_REQUEST:
    case GET_USER_WITH_ACTIVE_ADDRESS_REQUEST:
    case USER_UPDATE_PROFILE_REQUEST:
      return { ...state, isLoading: true, error: null };

    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      return { ...state, isLoading: false, error: null, jwt: action.payload };

    case OTP_SUCCESS:
      return { ...state, isLoading: false, error: null, otp: action.payload };

    case VERIFY_OTP_SUCCESS:
      return { ...state, isLoading: false, error: null, jwt: action.payload };

    case SELLER_REGISTER_SUCCESS:
      return { ...state, isLoading: false, error: null, register: action.payload };

    case GET_USER_SUCCESS:
    case GET_USER_WITH_ACTIVE_ADDRESS_SUCCESS:
    case USER_UPDATE_PROFILE_SUCCESS:
      return { ...state, isLoading: false, error: null, user: action.payload };

    case REGISTER_FAILURE:
    case LOGIN_FAILURE:
    case OTP_FAILURE:
    case VERIFY_OTP_FAILURE:
    case GET_USER_FAILURE:
    case SELLER_REGISTER_FAILURE:
    case GET_USER_WITH_ACTIVE_ADDRESS_FAILURE:
    case USER_UPDATE_PROFILE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
}